import { useCallback } from 'react';
import { useUploadProjectFile, useUploadProjectFileVersion } from '@/features/upload-project-file';
import type { ResolvedUpload } from '@/features/project-file-upload-guard';

/**
 * Uploads fresh and versioned uploads to a folder
 */
export function useFileUploadToFolder(projectId: string, folderId: string) {
  const upload = useUploadProjectFile({ projectId, folderId });
  const uploadVersion = useUploadProjectFileVersion({ projectId, folderId });

  const startUpload = useCallback(
    (items: ResolvedUpload[]) => {
      for (const item of items) {
        if (item.kind === 'version') {
          uploadVersion.mutate({
            file: item.file,
            fileId: item.fileId,
            knownLatestVersionId: item.knownLatestVersionId,
          });
        } else {
          upload.mutate(item.file);
        }
      }
    },
    [upload, uploadVersion],
  );

  return {
    startUpload,
    isUploading: upload.isPending,
    isError: upload.isError,
    error: upload.error,
    resetError: upload.reset,
  };
}
